import { render, staticRenderFns } from "./Jan16.vue?vue&type=template&id=6b3dbab6&scoped=true&"
import script from "./Jan16.vue?vue&type=script&lang=js&"
export * from "./Jan16.vue?vue&type=script&lang=js&"
import style0 from "./Jan16.vue?vue&type=style&index=0&id=6b3dbab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3dbab6",
  null
  
)

export default component.exports